const userLogUtils = {
    translateModule(name) {
        const names = {
            user: 'Usuário',
            category: 'Categoria',
            comment: 'Comentário',
            post: 'Post',
            course: 'Curso',
            faq: 'FAQ',
            student: 'Estudante',
            event: 'Evento',
            option: 'Menu',
            page: 'Página',
        }
        return names[name] || name
    },
    translateAction(action) {
        const actions = {
            create: 'Criar',
            update: 'Atualizar',
            destroy: 'Deletar',
        }
        return actions[action] || action
    }
}

export default userLogUtils
